import { render, staticRenderFns } from "./GetStartedView.vue?vue&type=template&id=4aeaa878&"
import script from "./GetStartedView.vue?vue&type=script&lang=ts&"
export * from "./GetStartedView.vue?vue&type=script&lang=ts&"
import style0 from "./GetStartedView.vue?vue&type=style&index=0&id=4aeaa878&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports